import React from 'react';
import QRLINEOA from 'assets/QR_140ffoit.png';
import { LazyLoadImage } from "react-lazy-load-image-component";
import PlaceholderImage from 'assets/logo_full.png';
import SectionHeader from 'components/common/SectionHeader';

export default function ContactUs() {
  return (
    <section className="contact-card" aria-label="ติดต่อเรา">
      <SectionHeader icon="💬" title="ติดต่อเรา" subtitle="สอบถามหรือแนะนำฟีเจอร์ใหม่" />
      <div className="contact-card__links">
        <a
          href="mailto:admin@hotto.app?subject=ติดต่อเจ้าหน้าที่%20hotto.app"
          className="contact-chip"
        >
          ✉️ admin@hotto.app
        </a>
        <a
          href="https://line.me/R/ti/p/%40140ffoit"
          className="contact-chip contact-chip--line"
          target="_blank"
          rel="noopener noreferrer"
        >
          💚 LINE @140ffoit
        </a>
      </div>
      <LazyLoadImage
        src={QRLINEOA}
        alt="QR code LINE OA Hotto"
        className="contact-card__qr"
        placeholdersrc={PlaceholderImage}
        effect="blur"
      />
    </section>
  );
}
